import { cn } from "../utils/cn.ts";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";

interface AddressTextDisplayProps {
  className?: string;
}

export const AddressTextDisplay = ({ className }: AddressTextDisplayProps) => {
  const { displayAddress = "" } = usePropertyDetailsContext();
  const parts = displayAddress.split(",").map((part) => part.trim());
  return (
    <div className={cn("flex flex-wrap h-[1lh] overflow-hidden", className)}>
      {parts.map((part, index) => (
        <span key={index} className="whitespace-nowrap text-ellipsis overflow-hidden">
          {index > 0 ? `, ${part}` : part}
        </span>
      ))}
    </div>
  );
};
